import React, { useEffect, useState } from "react";
import LiquidGlassModal from "../modal/LiquidGlassModal.js";
import { API_SUBMIT_FORM, BASE_URL } from "../../../../config/constants.js";

export default function ContactFormLiquid({ message }) {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState({
    open: false,
    success: false,
  });
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      message: message || "",
    }));
  }, [message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    const params = new URLSearchParams(formData);
    const urlWithParams = `${BASE_URL + API_SUBMIT_FORM}?${params.toString()}`;
    console.log("urlwith", urlWithParams);
    try {
      fetch(urlWithParams)
        .then((res) => {
          const errorMessage = res.headers.get("Error-Message");
          if (errorMessage) {
            console.error("Server Error:", errorMessage, res);
          }
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(() => {
          setLoading(false);
          setIsSuccessModalOpen({ open: true, success: true });
          setFormData({ name: "", email: "", phone: "", message: "" });
        })
        .catch((e) => {
          setLoading(false);
          setIsSuccessModalOpen({ open: true, success: false });
        });
    } catch {
      setIsSuccessModalOpen({ open: true, success: false });
    }
  };

  const closeModal = () => {
    setIsSuccessModalOpen({ open: false, success: false });
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    // Name should not be empty
    if (!formData.name.trim()) {
      newErrors.name = "Please enter your full name.";
      valid = false;
    } else {
      newErrors.name = "";
    }

    // Email validation using a regular expression
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    } else {
      newErrors.email = "";
    }

    // Phone number validation using a regular expression
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit phone number.";
      valid = false;
    } else {
      newErrors.phone = "";
    }

    // Message should not be empty
    if (!formData.message.trim()) {
      newErrors.message = "Please enter your enquiry.";
      valid = false;
    } else {
      newErrors.message = "";
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <section className="section-liquid contact-form-section">
      <div className="container-liquid">
        <div
          className="contact-form-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
            gap: "60px",
            alignItems: "center",
          }}
        >
          {/* Left Content */}
          <div style={{ animation: "fadeIn 0.8s ease-out" }}>
            <span className="subheading-liquid">Contact Us</span>
            <h2
              className="heading-liquid"
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                marginTop: "16px",
                marginBottom: "24px",
              }}
            >
              Let's Build Something{" "}
              <span
                style={{
                  background: "var(--gradient-primary)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  color: "var(--primary)", // Fallback
                  position: "relative",
                }}
              >
                Amazing
                <span
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    width: "100%",
                    height: "3px",
                    background: "var(--gradient-primary)",
                    borderRadius: "2px",
                    animation: "fadeIn 1s ease-out 0.5s both",
                  }}
                />
              </span>
            </h2>
            <p
              className="text-liquid"
              style={{
                fontSize: "1.2rem",
                marginBottom: "40px",
                lineHeight: "1.6",
                opacity: 0.9,
              }}
            >
              Ready to take your business online? Get in touch with us and let's
              discuss how we can help you achieve your digital goals. We're
              excited to work with you! ✨
            </p>

            {/* Enhanced Contact Cards */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                marginBottom: "32px",
              }}
            >
              <div
                className="glass-secondary glow"
                style={{
                  padding: "24px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  animation: "contactFloat 6s ease-in-out infinite",
                  animationDelay: "0s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px) scale(1.02)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0) scale(1)";
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "15px",
                    background:
                      "linear-gradient(135deg, #007AFF 0%, #5856D6 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    boxShadow: "0 8px 25px rgba(0, 122, 255, 0.3)",
                  }}
                >
                  📧
                </div>
                <div>
                  <span
                    className="text-liquid"
                    style={{ fontWeight: "600", display: "block" }}
                  >
                    Email Us
                  </span>
                  <span
                    className="text-liquid"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    onlinebadho.ind@gmail.com
                  </span>
                </div>
              </div>

              <div
                className="glass-secondary glow"
                style={{
                  padding: "24px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  animation: "contactFloat 6s ease-in-out infinite",
                  animationDelay: "1s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px) scale(1.02)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0) scale(1)";
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "15px",
                    background:
                      "linear-gradient(135deg, #34C759 0%, #32D74B 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    boxShadow: "0 8px 25px rgba(52, 199, 89, 0.3)",
                  }}
                >
                  📱
                </div>
                <div>
                  <span
                    className="text-liquid"
                    style={{ fontWeight: "600", display: "block" }}
                  >
                    Call Us
                  </span>
                  <span
                    className="text-liquid"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    +91 (986) 777-9087
                  </span>
                </div>
              </div>
            </div>

            {/* Quick Stats */}
            <div
              className="glass-secondary"
              style={{
                padding: "20px",
                borderRadius: "20px",
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "16px",
                textAlign: "center",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "var(--primary)",
                  }}
                >
                  50+
                </div>
                <div style={{ fontSize: "0.85rem", opacity: 0.7 }}>
                  Projects
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "var(--primary)",
                  }}
                >
                  24hrs
                </div>
                <div style={{ fontSize: "0.85rem", opacity: 0.7 }}>
                  Response
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: "var(--primary)",
                  }}
                >
                  100%
                </div>
                <div style={{ fontSize: "0.85rem", opacity: 0.7 }}>
                  Satisfied
                </div>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div
            className="glass liquid-float"
            style={{
              padding: "48px",
              animation: "fadeIn 0.8s ease-out 0.2s both",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative Background Elements */}
            <div
              style={{
                position: "absolute",
                top: "-50%",
                right: "-30%",
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(94, 129, 244, 0.1) 0%, transparent 70%)",
                animation: "contactFloat 8s ease-in-out infinite",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-30%",
                left: "-20%",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(52, 199, 89, 0.1) 0%, transparent 70%)",
                animation: "contactFloat 6s ease-in-out infinite reverse",
              }}
            />

            <div style={{ position: "relative", zIndex: 1 }}>
              {/* Form Header */}
              <div style={{ marginBottom: "32px", textAlign: "center" }}>
                <h3
                  className="heading-liquid"
                  style={{
                    fontSize: "1.5rem",
                    marginBottom: "8px",
                    background: "var(--gradient-primary)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "var(--primary)", // Fallback
                  }}
                >
                  Send us a message 💬
                </h3>
                <p
                  className="text-liquid"
                  style={{ opacity: 0.7, fontSize: "0.95rem" }}
                >
                  We'll get back to you within 24 hours
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: "24px" }}>
                  <label
                    className="text-liquid"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                    }}
                  >
                    Name <span style={{ color: "#ff6b6b" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="glass-secondary"
                    style={{
                      width: "100%",
                      padding: "18px",
                      border: errors.name
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      fontSize: "1rem",
                      color: "var(--text-primary-dark)",
                      backgroundColor: "transparent",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    placeholder="Enter your full name"
                    required
                    onFocus={(e) => {
                      e.target.style.animation = "inputGlow 0.3s ease-out";
                      e.target.style.border =
                        "2px solid rgba(94, 129, 244, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.animation = "";
                      e.target.style.border = errors.name
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)";
                    }}
                  />
                  {errors.name && (
                    <span
                      style={{
                        color: "#ff6b6b",
                        fontSize: "0.875rem",
                        marginTop: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      ⚠️ {errors.name}
                    </span>
                  )}
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <label
                    className="text-liquid"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                    }}
                  >
                    Email <span style={{ color: "#ff6b6b" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="glass-secondary"
                    style={{
                      width: "100%",
                      padding: "18px",
                      border: errors.email
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      fontSize: "1rem",
                      color: "var(--text-primary-dark)",
                      backgroundColor: "transparent",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    placeholder="Enter your email address"
                    required
                    onFocus={(e) => {
                      e.target.style.animation = "inputGlow 0.3s ease-out";
                      e.target.style.border =
                        "2px solid rgba(94, 129, 244, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.animation = "";
                      e.target.style.border = errors.email
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)";
                    }}
                  />
                  {errors.email && (
                    <span
                      style={{
                        color: "#ff6b6b",
                        fontSize: "0.875rem",
                        marginTop: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      ⚠️ {errors.email}
                    </span>
                  )}
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <label
                    className="text-liquid"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                    }}
                  >
                    Phone <span style={{ color: "#ff6b6b" }}>*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="glass-secondary"
                    style={{
                      width: "100%",
                      padding: "18px",
                      border: errors.phone
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      fontSize: "1rem",
                      color: "var(--text-primary-dark)",
                      backgroundColor: "transparent",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    placeholder="Enter your phone number"
                    required
                    onFocus={(e) => {
                      e.target.style.animation = "inputGlow 0.3s ease-out";
                      e.target.style.border =
                        "2px solid rgba(94, 129, 244, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.animation = "";
                      e.target.style.border = errors.phone
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)";
                    }}
                  />
                  {errors.phone && (
                    <span
                      style={{
                        color: "#ff6b6b",
                        fontSize: "0.875rem",
                        marginTop: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      ⚠️ {errors.phone}
                    </span>
                  )}
                </div>

                <div style={{ marginBottom: "32px" }}>
                  <label
                    className="text-liquid"
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "600",
                      fontSize: "0.95rem",
                    }}
                  >
                    Message <span style={{ color: "#ff6b6b" }}>*</span>
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="glass-secondary"
                    style={{
                      width: "100%",
                      padding: "18px",
                      border: errors.message
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      fontSize: "1rem",
                      color: "var(--text-primary-dark)",
                      backgroundColor: "transparent",
                      minHeight: "120px",
                      resize: "vertical",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    placeholder="Tell us about your project, ideas, or how we can help you..."
                    required
                    onFocus={(e) => {
                      e.target.style.animation = "inputGlow 0.3s ease-out";
                      e.target.style.border =
                        "2px solid rgba(94, 129, 244, 0.5)";
                    }}
                    onBlur={(e) => {
                      e.target.style.animation = "";
                      e.target.style.border = errors.message
                        ? "2px solid #ff6b6b"
                        : "1px solid rgba(255, 255, 255, 0.1)";
                    }}
                  />
                  {errors.message && (
                    <span
                      style={{
                        color: "#ff6b6b",
                        fontSize: "0.875rem",
                        marginTop: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      ⚠️ {errors.message}
                    </span>
                  )}
                </div>

                <button
                  type="submit"
                  className="glass-button glass-button-primary glow"
                  style={{
                    width: "100%",
                    padding: "20px",
                    fontSize: "1.1rem",
                    fontWeight: "700",
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "12px",
                    borderRadius: "20px",
                    transition: "all 0.3s ease",
                    background: loading
                      ? "rgba(94, 129, 244, 0.6)"
                      : "linear-gradient(135deg, #5E81F4 0%, #7C4DFF 100%)",
                    transform: loading ? "scale(0.98)" : "scale(1)",
                  }}
                  disabled={loading}
                  onMouseEnter={(e) => {
                    if (!loading) {
                      e.target.style.transform = "scale(1.02) translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 20px 40px rgba(94, 129, 244, 0.4)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loading) {
                      e.target.style.transform = "scale(1) translateY(0)";
                      e.target.style.boxShadow = "";
                    }
                  }}
                >
                  {loading ? (
                    <>
                      <div
                        style={{
                          width: "22px",
                          height: "22px",
                          border: "3px solid rgba(255,255,255,0.3)",
                          borderTop: "3px solid white",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      Sending your message...
                    </>
                  ) : (
                    <>
                      <span>🚀</span>
                      Send Message
                    </>
                  )}
                </button>

                {/* Trust Indicators */}
                <div
                  style={{
                    marginTop: "20px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "16px",
                    fontSize: "0.85rem",
                    opacity: 0.7,
                  }}
                >
                  <span>🔒 Secure</span>
                  <span>⚡ Fast Response</span>
                  <span>💯 Reliable</span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <LiquidGlassModal
        isOpen={isSuccessModalOpen.open}
        success={isSuccessModalOpen.success}
        onClose={closeModal}
        successMessage="Thank you for your message! We'll get back to you soon."
        errorMessage="Sorry, there was an error sending your message. Please try again."
      />
    </section>
  );
}
